export enum CampaignState{
    Waitting = 'waiting',
    Running = 'running',
    Suspended = 'suspended',
    Stopped = 'stopped'
}
